module.exports = __webpack_public_path__ + "static/media/LevelUpgradeGold.7b96981a.png";